import axios from '@shared/services/api/axiosConfig.js';
import { getAuthHeaders } from '@shared/services/auth/authApiServices.js';

const debug = process.env.NODE_ENV !== 'production';

export default {
  async getProposalComments(proposalId){
    const headers = await getAuthHeaders();
    const res = await axios.get(`/api/proposal/${proposalId}/comments`, headers)
    if (debug) console.log('getProposalFill', res);
    return res;
  },
  async postComment(proposalId, payload){
    const headers = await getAuthHeaders();
    const res = await axios.post(`/api/proposal/${proposalId}/comment`, payload, headers)
    return res;
  },
  async deleteComment(proposalId, commentId){
    const headers = await getAuthHeaders();
    const res = await axios.delete(`/api/proposal/${proposalId}/comment/${commentId}`, headers);
    return res;
  },
}
